import { Component, OnInit } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-grid-formly-cell',
  templateUrl: './grid-formly-cell.component.html',
  styleUrls: ['./grid-formly-cell.component.scss']
})
export class GridFormlyCellComponent implements ICellRendererAngularComp {

  public params: any;

  agInit(params: any): void {
    this.params = params;
  }

  refresh(): boolean {
    return false;
  }

  getField(): FormlyFieldConfig {
    const rowIndex = this.params.node.rowIndex;
    const prop = this.params.colDef.field;
    const parentField = this.params.context.parentField;
    return parentField.get([rowIndex, prop]);
  }
}
